import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const GyikSection = () => {
  const faqsLeft = [
    {
      q: "Nekem már van weboldalam. Miért kellene új?",
      a: "Lehet egy második is. Vagy ha meglévő a weboldal nem hoz érdeklődőt, akkor vagy az üzenet, vagy a struktúra, vagy a CTA gyenge. Sokszor egy célzott landing több érdeklődést hoz, mint egy \"mindenről szóló\" oldal. És a két típusú oldal megfér egymás mellett."
    },
    {
      q: "Nem túl rövid egy egyoldalas oldal?",
      a: "Nem a hossza számít, hanem a logikája. A jó landing nem rövid vagy hosszú — hanem megállítja a látogatót, és döntésre segít."
    },
    {
      q: "Ki írja a szöveget?",
      a: "Mi megírjuk. Olyan hangon, ami a te ügyfeleidnek érthető, és ami bizalmat épít."
    },
    {
      q: "Mi van, ha változtatni akarok később?",
      a: "Lehetséges finomhangolás. A rendszer úgy van felépítve, hogy ne omoljon össze, ha bővíteni kell."
    },
    {
      q: "SEO lesz rajta?",
      a: "A SEO rendben lesz (strukturált szöveg, logikus címek). Google strukturált adatok ha szükséges."
    },
    {
      q: "Mennyi idő alatt lehet kész?",
      a: "Egy weboldal teljes elkészítése a tervezéstől a kész termékig általában 2-5 munkanap. A folyamat kifejezetten úgy van kitalálva, hogy ne csússzon el hetekig: célzott kérdések → első verzió → finomhangolás."
    },
    {
      q: "Mitől lesz 'prémium' egy landing, ha csak egy oldal?",
      a: "A prémium nem az oldalszám, hanem az élmény és az eredmény: a vizuális minőség, a tiszta ajánlat, a jó struktúra, a konverziós elemek (CTA-k, bizalomépítés, kifogáskezelés) és a mobilos használhatóság. Egy jó landing sokszor többet ér, mint egy \"mindent is\" weboldal."
    },
    {
      q: "Milyen anyagokat kell adnom?",
      a: "Minimum elég: mivel foglalkozol, kinek, mi a fő ajánlat, mi a leggyakoribb kérdés/kifogás, és hogyan szeretnéd, hogy keressenek (telefon/űrlap). Ha van: logó, 2–5 fotó, referenciák, vélemények, videó — ezek csak erősítik."
    }
  ];

  const faqsRight = [
    {
      q: "Ha nincs profi fotóm, akkor is lehet jó?",
      a: "Igen. Megoldható vizuális koncepcióval, illusztrációval, UI-mockup jellegű elemekkel, és olyan layouttal, ami fotók nélkül is prémium. Ha később lesz fotó, könnyen cserélhető."
    },
    {
      q: "Kapok hozzá domain és e-mail címet is?",
      a: "Domain és céges e-mail igény esetén segítünk a beállításban (hogy ne legyen kínszenvedés), és elmondjuk a legjobb, egyszerű megoldást. A domain regisztráció általában a te neveden fut — ez a tiszta, korrekt."
    },
    {
      q: "A weboldal mobilon tényleg jól fog kinézni?",
      a: "Igen, mobil-first logikával épül: rövid, jól tagolt blokkok, nagy gombok, könnyű olvashatóság, és mobil sticky CTA, hogy a látogató mindig tudja, mi a következő lépés."
    },
    {
      q: "Mit mérünk rajta? Honnan tudom, hogy működik?",
      a: "Alap szinten beállítható a látogatottsági mérés, és meg tudjuk mondani, mit érdemes figyelni (pl. melyik CTA-t nyomják, hol esik le a figyelem). Ha komolyabb konverziómérés kell (pixel, események, kampány), az az Egyedi ajánlat része."
    },
    {
      q: "Tudtok hirdetésre optimalizált verziót is?",
      a: "Igen. Ha hirdetésből jön a forgalom, más a fókusz: rövidebb út, erősebb ajánlat-keret, több bizalom-elem, és kampány-kompatibilis CTA-k. Ez lehet ugyanaz a landing, vagy külön kampány-landing."
    },
    {
      q: "Mi történik, ha nem tetszik az első verzió?",
      a: "Az első verzió egy irány és struktúra — nem végleges. A visszajelzéseid alapján finomhangolunk: hangsúlyok, szöveg, sorrend, CTA-k. A cél, hogy a landing \"rólad szóljon\", ne egy generikus sablon legyen."
    },
    {
      q: "Kaphatok több verziót (A/B)?",
      a: "Igen, kérhető több headline/hero/CTA variáció, vagy akár két külön landing verzió, ha két célcsoportod van. Ez tipikusan az Egyedi ajánlat része, mert extra stratégiai munka."
    },
    {
      q: "Miért jobb ez, mint egy 'olcsó weboldalkészítő' platform?",
      a: "Mert nem csak \"összerakunk valamit\", hanem gondolkodunk: üzenet, ajánlat, sorrend, bizalom, kifogáskezelés, CTA-logika. Egy platform ad egy sablont — mi meg egy ügyfélszerző rendszert adunk egy oldalban."
    }
  ];

  return (
    <section id="gyik" data-testid="gyik-section" className="light-band py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text text-center">
            Gyakori kérdések
          </h2>

          <div className="scroll-animate-stagger scroll-animate mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left column */}
            <div className="card-light rounded-3xl p-6 faq-accordion">
              <Accordion type="single" collapsible className="space-y-2">
                {faqsLeft.map((faq, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-left-${i}`}
                    className="border border-ink-text/5 rounded-xl px-5 data-[state=open]:border-primary/20 transition-colors"
                  >
                    <AccordionTrigger className="text-left font-medium text-ink-text hover:no-underline py-4 text-sm">
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-text pb-4 text-sm">
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>

            {/* Right column */}
            <div className="card-light rounded-3xl p-6 faq-accordion">
              <Accordion type="single" collapsible className="space-y-2">
                {faqsRight.map((faq, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-right-${i}`}
                    className="border border-ink-text/5 rounded-xl px-5 data-[state=open]:border-primary/20 transition-colors"
                  >
                    <AccordionTrigger className="text-left font-medium text-ink-text hover:no-underline py-4 text-sm">
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-text pb-4 text-sm">
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>

          <p className="scroll-animate mt-8 text-center text-muted-text">
            Más kérdésed van? Írj, és megbeszéljük.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GyikSection;
